// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:30:41

export default {
  "id": "sokoban-pr",
  "slug": "sokoban-pr",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/1f295d50c3d842fd9f4e6b34dd9502d2-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/1f295d50c3d842fd9f4e6b34dd9502d2/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sokoban P/R",
      "description": "Help the adorable loader handle his daily tasks in the classic Sokoban puzzle! Enjoy simple design, clever challenges, and the ability to develop your own strategy. Levels will gradually expand, so you can always test your skills. The best puzzle solutions await you!",
      "instructions": "Your goal is to move boxes to their designated spots, solving tasks that grow more challenging with each level.\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "block",
        "challenge",
        "sliding"
      ]
    },
    "zh-CN": {
      "title": "推箱子/推箱人",
      "description": "帮助可爱的小推车手处理日常任务，体验经典的推箱子益智游戏！享受简洁的设计、巧妙的挑战以及制定自己策略的能力。关卡将逐步扩展，您可以随时测试自己的技能。最佳的谜题解决方案等待着您！",
      "instructions": "你的目标是移动箱子到指定的位置，解决的任务随着每个级别的提升而变得越来越具有挑战性。",
      "genres": [
        "谜题"
      ],
      "tags": [
        "1玩家",
        "防御",
        "挑战",
        "滑动"
      ]
    },
    "zh-TW": {
      "title": "蘇貴南 P/R",
      "description": "幫助可愛的輸送員處理日常任務，在經典的Sokoban謎題中享受樂趣！欣賞簡單的設計、巧妙的挑戰，以及發展自己的策略的能力。關卡將逐漸擴大，您可以永遠挑戰自己的技巧。最優的謎題解法等著您！",
      "instructions": "您的目標是將箱子移動到指定的位置，解決隨著每個關卡變得更具挑戰性的任務。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "阻擋",
        "挑戰",
        "滑動"
      ]
    },
    "zh-HK": {
      "title": "擺盤獨逸/人氣評比",
      "description": "幫助可愛的載貨員處理他每日的工作任務，在經典的Sokoban迷宮遊戲中！享受簡潔的設計、巧妙挑戰，以及發展自己策略的能力。等級將逐漸擴張，讓你可以無限次地測試你的技巧。最佳的迷宮解法等你來挑戰！",
      "instructions": "你的目標是將箱子移至指定的位置，解決隨著每關難度逐漸上升的任務。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "堵截",
        "挑戰",
        "滑動"
      ]
    },
    "ja": {
      "title": "ソコバン P/R",
      "description": "可愛いローダーが毎日のタスクをクラスターSokobanパズルでこなそう！シンプルなデザイン、賢い挑戦、そして自分自身の戦略を展開できる機能を楽しみましょう。レベルは徐々に拡大し、常にあなたのスキルを試すことができます。最も良いパズル解決策があなたを待っています！",
      "instructions": "あなたのゴールは、箱を指定された場所に移動させ、レベルごとに難易度が上がるタスクを解決することです。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "ブロック",
        "挑戦",
        "スライディング"
      ]
    },
    "ko": {
      "title": "소코반 P/R",
      "description": "좋아하는 로더가 일상적인 업무를 소코반 퍼즐에서 처리해 주세요! 간단한 디자인, 지혜로운 도전, 자신만의 전략을 개발할 수 있는 기회를 즐겨보세요. 레벨은 점차 확장되어, 능력을 항상 테스트할 수 있습니다. 최고의 퍼즐 해결책이 기다리고 있습니다!",
      "instructions": "목표는 상자를 지정된 위치로 이동시키고, 각 레벨마다 더 어려워지는 작업을 해결하는 것입니다.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "블록",
        "도전",
        "슬라이딩"
      ]
    },
    "fr": {
      "title": "Sokoban P/R\n- P/R 在此可能指的是 \"Player/Reader\"，即玩家/读者。如果这是针对游戏术语的缩写，则可能表示玩家或游戏中的某个角色。具体翻译如下：\n\n- Sokoban P/R : Sokoban Joueur/Lecteur",
      "description": "Aidez l'adorable chargeur à gérer ses tâches quotidiennes dans le classique puzzle Sokoban ! Profitez de la conception simple, des défis intelligents et de la capacité de développer votre propre stratégie. Les niveaux s'élargiront progressivement, afin que vous puissiez toujours tester vos compétences. Les meilleures solutions de puzzle vous attendent !",
      "instructions": "Votre objectif est de déplacer des boîtes vers leurs emplacements désignés, en résolvant des tâches de plus en plus difficiles à chaque niveau.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "bloquer",
        "défi",
        "glisser"
      ]
    }
  }
};
